import { render, staticRenderFns } from "./approving.vue?vue&type=template&id=ab58e5b4"
import script from "./approving.vue?vue&type=script&lang=js"
export * from "./approving.vue?vue&type=script&lang=js"
import style0 from "./approving.vue?vue&type=style&index=0&id=ab58e5b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports